import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AccountService} from "../account/account.service";
import {CampaignService} from "./campaign.service";
import {CommonDataService} from "../shared/services/common-data.service";
import {SettingsService} from "../settings/settings.service";

@Component({
    selector: 'app-campaign',
    templateUrl: './campaign.component.html'
})
export class CampaignComponent implements OnInit {

    currentUser;
    campaigns = [];

    constructor(private router: Router,
                private accountService: AccountService,
                private campaignService: CampaignService,
                private cdService: CommonDataService,
                private settingsService: SettingsService) {
    }

    ngOnInit() {

        this.settingsService.currentUser().subscribe(user => {
            this.currentUser = user;
        }, error => {
            console.log('Error get current user');
        });

        this.campaignService.getCampaigns().subscribe(data => {
            data.forEach(element => {
                if (!element.completed) {
                    this.campaigns.push({id: element.id, value: element.campaignname, startDate: new Date(element.startdate)});
                }
            });
            // this.campaigns.sort(function(a, b){
            //     let x = a.value.toLowerCase();
            //     let y = b.value.toLowerCase();
            //     if (x < y) {return -1;}
            //     if (x > y) {return 1;}
            //     return 0;
            // });

            if (this.campaigns.length === 0) {
                this.campaignService.broadcastCampaignId(null);
                this.router.navigate(['campaign', 'create']);
            } else if (this.campaigns.length >= 1) {
                this.campaignService.broadcastCampaignId(this.campaigns[0].id);
                if (this.campaignService.isCampaignEnding(this.campaigns[0].startDate)) {
                    this.router.navigate(['campaign', 'complete', this.campaigns[0].id]);
                } else {
                    this.router.navigate(['campaign', 'manage', this.campaigns[0].id]);
                }
            }

        }, err => {
            this.campaigns = [];
            this.router.navigate(['campaign', 'create']);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign.component.ts